import clsx from 'clsx';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { IconsFill, InfoOutlineIcon } from 'src/svgs/Viagogo';

import * as styles from './MessageWithIcon.css';

export const InfoMessage = ({
  message,
  fill = IconsFill.textPrimary,
  iconSize = vars.iconSize.l,
  style,
  className,
}: {
  message: string | JSX.Element;
  fill?: IconsFill;
  iconSize?: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  return (
    <Stack
      direction="row"
      gap="m"
      className={clsx(styles.messageContainer, className)}
      style={style}
    >
      <InfoOutlineIcon fill={fill} size={iconSize} />
      <div className={styles.messageDiv}>{message}</div>
    </Stack>
  );
};
